import * as ActionTypes from './MultiplePhotographersInvoiceActionTypes';
import { assign } from '../../../../shared/Assign';
import InitialState from './InitialState';

export default function multiplePhotographersInvoiceReducer(
    state: any = InitialState,
    action: { type: string; result: any }
) {
    switch (action.type) {
        case ActionTypes.GET_PHOTOGRAPHER_INVOICE_COLLECTION_LISTS_SUCCESS: {
            const newState = assign({}, state);
            newState.previewInvoiceCollections = action.result.previews;
            newState.pendingInvoiceCollections = action.result.pending;
            newState.invoiceCollectionHistory = action.result.history;
            newState.html = '';
            newState.checksums = null;
            newState.rejections = [];
            newState.exclusions = [];
            newState.outliers = action.result.outliers;
            newState.topTenCosts = action.result.topTenCosts;
            newState.passivePhotographers = [];
            return newState;
        }

        case ActionTypes.CLEAR_PHOTOGRAPHER_INVOICE_COLLECTIONS_STATE:
            return InitialState;

        case ActionTypes.GET_PHOTOGRAPHER_INVOICE_COLLECTION_SUCCESS: {
            const newState = assign({}, state);
            newState.html = action.result.html;
            newState.checksums = action.result.checksums;
            newState.rejections = action.result.rejections;
            newState.exclusions = action.result.exclusions;
            newState.outliers = action.result.outliers;
            newState.topTenCosts = action.result.topTenCosts;
            newState.passivePhotographers = action.result.passivePhotographers;
            return newState;
        }

        default:
            return state;
    }
}
